import * as React from "react"

const Farcaster = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M4.0592 2.5h7.7396v11h-1.1361V8.4613h-.0111C10.526 7.0687 9.355 5.9774 7.929 5.9774S5.332 7.0687 5.2064 8.4613h-.0111V13.5H4.0592v-11Z" />
    <path d="m2 4.0613.4615 1.5613h.3906v6.3161a.355.355 0 0 0-.355.3548v.4259h-.071a.3549.3549 0 0 0-.355.3548V13.5h3.9762v-.4258a.3549.3549 0 0 0-.355-.3548h-.071v-.4259a.355.355 0 0 0-.355-.3548h-.426V4.0613H2Zm8.7337 7.8774a.355.355 0 0 0-.355.3548v.4259h-.071a.3549.3549 0 0 0-.355.3548V13.5h3.9763v-.4258a.355.355 0 0 0-.355-.3548h-.071v-.4259a.355.355 0 0 0-.3551-.3548V5.6226h.3906L14 4.0613h-2.8402v7.8774h-.4261Z" />
  </svg>
)

export default Farcaster
